// extracted by mini-css-extract-plugin
export var box = "Directions-module--box--57f0c";
export var box_md = "Directions-module--box_md--8c1be";
export var box_xmd = "Directions-module--box_xmd--2e414";
export var box_flex = "Directions-module--box_flex--cbf06";
export var box_lg = "Directions-module--box_lg--d7099";
export var box_sm = "Directions-module--box_sm--48722";
export var box_outer = "Directions-module--box_outer--19384";
export var box_whiteBg = "Directions-module--box_white-bg--77bf7";
export var box_noMarginBottom = "Directions-module--box_no-margin-bottom--5111f";
export var box_noPadding = "Directions-module--box_no-padding--e02d3";
export var box_outerGray = "Directions-module--box_outer-gray--fd948";
export var box_dark = "Directions-module--box_dark--acbb5";
export var box_zIndex = "Directions-module--box_z-index--fa7ff";
export var box_zIndex6 = "Directions-module--box_z-index-6--0a427";
export var box_eventsWithLine = "Directions-module--box_events-with-line--97dff";
export var box_featuresAo = "Directions-module--box_features-ao--72759";
export var box_verticalPaddings = "Directions-module--box_vertical-paddings--4a1af";
export var clearP = "Directions-module--clearP--51c03";
export var clearP_vc = "Directions-module--clearP_vc--5fdc8";
export var wrapper = "Directions-module--wrapper--84551";
export var title = "Directions-module--title--a3fd4";
export var layout = "Directions-module--layout--ed10b";
export var fadeInAnimation = "Directions-module--fadeInAnimation--31bd3";
export var placeHolderShimmer = "Directions-module--placeHolderShimmer--0b6ad";